import { useEffect, useState } from 'react';

import { isProductionEnvironment } from '~/main/environments';
import { LoggerScope } from '~/main/utils/logger';
import Logger from '~/renderer/utils/logger';

import { useTrackCFDConnected } from './appcues/use-track-cfd-connected';
import { useTrackReceiptPrinterConnected } from './appcues/use-track-receipt-printer-connected';

export enum APPCUES_EVENTS {
  RECEIPT_PRINTER_CONNECTED = '[Hub] Receipt printer connected',
  CFD_CONNECTED = '[Hub] CFD connected',
}

export const useAppcues = (accountId: string = '') => {
  const appID = '46996';
  const [isUserIdentified, setIsUserIdentified] = useState(false);
  const [isAppcuesLoaded, setIsAppcuesLoaded] = useState(false);

  const setAppcuesUser = (id: string) => {
    if (!window.Appcues) {
      return;
    }
    if (id) {
      window.Appcues.identify(id);
      setIsUserIdentified(true);
    } else {
      window.Appcues.anonymous();
    }

    Logger({ scope: LoggerScope.APPCUES }).debug({
      msg: 'identified user',
      id: id || 'anonymous',
    });
  };

  useEffect(() => {
    if (!isProductionEnvironment()) return;

    const script = document.createElement('script');
    script.src = `https://fast.appcues.com/${appID}.js`;
    script.async = true;
    script.onload = () => setIsAppcuesLoaded(true);
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setAppcuesUser(accountId);
  }, [accountId, isAppcuesLoaded]);

  useTrackCFDConnected(isUserIdentified);
  useTrackReceiptPrinterConnected(isUserIdentified);
};
